import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  Button,
  Box,
  IconButton,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Formik } from "formik";
import CloseIcon from "@material-ui/icons/CloseRounded";
import Grid2 from "@mui/material/Unstable_Grid2";

const useStyles = makeStyles((theme) => ({
  accessBox: {
    display: "flex",
    flexFlow: "column",
  },
  publishButton: {
    color: theme.palette.common.white,
  },
  scrollContainer: {
    maxHeight: "70vh",
    overflowY: "auto",
    backgroundColor: "#f3f3f3",
  },
  dialogPaper: {
    maxWidth: '400px',
  },
}));

export default function ChangeAdminStatusDialogComponent({
  open,
  handleSubmit,
  handleClose,
  isEnabled,
}) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll="paper"
      classes={{ paper: classes.dialogPaper }}
      fullWidth
    >
      <DialogTitle id="scroll-dialog-title">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box flexGrow={1}>
              <Typography fontSize={16}>
                Confirm {isEnabled ? "Deactivate" : "Activate"} Admin
              </Typography>
            </Box>
          </Box>

          <IconButton
            size="small"
            color="inherit"
            onClick={handleClose}
            style={{ padding: 0 }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent style={{ backgroundColor: 'white' }} dividers className={classes.scrollContainer}>
        Are you sure to {isEnabled ? "Deactivate" : "Activate"} this admin ?
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          type="button"
          onClick={handleClose}
          style={{ color: "black" }}
        >
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSubmit}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
